import AboutSystemController from "./about-system-controller";
import { connect } from "react-redux";
import { compose } from "redux";
import { withAuthRedirect } from "hoc/AuthRedirect";
import { getChangeLogs } from "store/change-log";
import { getValue } from 'store/languages';

let mapStateToProps = (state) => {
    return {
        //changeLogs: getChangeLogsSelector(state),
        changeLogs:  state.ChangeLog.changeLogs,
        totalElements: state.ChangeLog.totalElements,
        selectedLanguage: state.languages.selectedLanguage,
        count: state.ChangeLog.totalElements,
        page: state.ChangeLog.page,
        showedItemsCount: state.paginator.showedItemsCount,
        currentPage: state.paginator.currentPage,
    }
}

export default compose(
    connect(mapStateToProps, {getValue, getChangeLogs}),
    withAuthRedirect
)(AboutSystemController)